import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';

import { IScheduleOverride } from '@cakeiteasy/web-utils';

import { DeliveryApiService } from '../../api-services/services/delivery-api.service';

const CACHE_TTL_MS = 5 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class OutletScheduleOverridesFacadeService {
  public scheduleOverridesByOutletId: { [outletId: number]: IScheduleOverride[] } = {};

  private loadedAtByKey = new Map<string, number>();
  private loadingByKey = new Map<string, Promise<void>>();

  constructor(private _deliveryApi: DeliveryApiService) {
  }

  public ensure(bakeryId: number, outletId: number): Promise<void> {
    if (!bakeryId || !outletId) {
      return Promise.resolve();
    }

    const key = `${bakeryId}:${outletId}`;

    if (this.isFresh(key)) {
      return Promise.resolve();
    }

    if (this.loadingByKey.has(key)) {
      return this.loadingByKey.get(key);
    }

    const loading = firstValueFrom(this._deliveryApi.getOutletScheduleOverrides(bakeryId, outletId))
      .then((scheduleOverrides) => {
        this.setOutletScheduleOverrides(key, outletId, scheduleOverrides);
      })
      .catch((e) => {
        console.error('OUTLET_SCHEDULE_OVERRIDES_ERROR: ', e);
        this.setOutletScheduleOverrides(key, outletId, []);
      }).finally(() => this.loadingByKey.delete(key));

    this.loadingByKey.set(key, loading);
  }

  private isFresh(key: string): boolean {
    const loadedAt = this.loadedAtByKey.get(key);
    return this.loadedAtByKey.has(key) && Date.now() - loadedAt < CACHE_TTL_MS;
  }

  private setOutletScheduleOverrides(key: string, outletId: number, scheduleOverrides: IScheduleOverride[] = []): void {
    this.scheduleOverridesByOutletId = {
      ...this.scheduleOverridesByOutletId,
      [outletId]: scheduleOverrides,
    };

    this.loadedAtByKey.set(key, Date.now());
  }
}
